import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Dialog } from 'primeng/dialog';

function getHost(): HTMLElement {
  const list = document.querySelectorAll<HTMLElement>('#panelSplitterMain');
  return list[list.length - 1] ?? document.body;
}

export function patchPrimeDynamicDialog(): () => void {
  return () => {
    const originalOpen = DialogService.prototype.open;
    DialogService.prototype.open = function <T>(this: DialogService, component: any, config: DynamicDialogConfig = {}) {
      if (config.appendTo == null) {
        config = { ...config, appendTo: getHost() };
      }
      return originalOpen.call(this, component, config);
    };
  };
}

export function patchPrimeDialog(): () => void {
  return () => {
    const original = Dialog.prototype.ngOnInit;
    Dialog.prototype.ngOnInit = function () {
      if (!this.appendTo) {
        this.appendTo = getHost();
      }
      original?.apply(this);
    };
  };
}
